import KpiApplicationPage from "./KpiApplicationPage";

export default KpiApplicationPage